export function generateSlug(name) {
  if (!name) return '';
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function createProductUrl(product) {
  const slug = product.slug || generateSlug(product.name || '');
  if (!slug) return '/';
  return `/products/${slug}`;
}

export function getProductIdFromSlug(slug) {
  if (!slug) return '';
  const parts = slug.split('--');
  const last = parts[parts.length - 1];
  if (parts.length > 1 && last && last.length === 20 && last.startsWith('-')) {
    return last;
  }
  return last || slug;
}
